// App.tsx
import React from 'react';
import FreeIPLocation from './components/FreeIPLocation';

const App: React.FC = () => {
  return (
    <FreeIPLocation />
  );
};

export default App;
